{
  "name": "Recruitwise",
  "version": "1.1.3",
  "scripts": {
    "ng": "ng",
    "build:libs": "ng build interview-rounds && ng build @tvangular/picklist && ng build @gs1/sliding-panel",
    "prestart": "npm run build:libs",
    "predev": "npm run build:libs",
    "preqa": "npm run build:libs",
    "preprod": "npm run build:libs",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "dev": "cross-env NG_APP_ENV=dev ng build --configuration development",
    "qa": "cross-env NG_APP_ENV=qa ng build --configuration qa",
    "prod": "cross-env NG_APP_ENV=production ng build --configuration production",
    "start:qa": "cross-env NG_APP_ENV=qa ng serve --configuration qa",
    "prepare": "husky",
    "commit": "cz",
    "release": "standard-version",
    "release:minor": "standard-version --release-as minor",
    "release:major": "standard-version --release-as major",
    "release:patch": "standard-version --release-as patch",
    "release:dry": "standard-version --dry-run"
  },
  "config": {
    "commitizen": {
      "path": "cz-conventional-changelog"
    }
  },
  "private": true,
  "overrides": {
    "ngx-toastr": {
      "@angular/core": "^22.1.3",
      "@angular/common": "^22.1.3"
    }
  },
  "dependencies": {
    "@abacritt/angularx-social-login": "2.0.0",
    "@angular/animations": "^22.1.3",
    "@angular/aria": "^22.1.3",
    "@angular/cdk": "^22.1.3",
    "@angular/common": "^22.1.3",
    "@angular/compiler": "^22.1.3",
    "@angular/core": "^22.1.3",
    "@angular/forms": "^22.1.3",
    "@angular/material": "^22.1.3",
    "@angular/platform-browser": "^22.1.3",
    "@angular/platform-browser-dynamic": "^22.1.3",
    "@angular/router": "^22.1.3",
    "@aws-sdk/client-s3": "^3.998.0",
    "@aws-sdk/s3-request-presigner": "^3.998.0",
    "@popperjs/core": "^2.11.8",
    "@tvangular/context-menu": "^0.1.3",
    "@tvangular/datepicker": "^0.1.5",
    "@tvangular/document-viewer": "^0.1.4",
    "@tvangular/file-upload": "^0.1.3",
    "@tvangular/image-viewer": "^0.1.1",
    "@tvangular/picklist": "^0.1.1",
    "@tvangular/scroll-to-top": "^0.1.2",
    "@tvangular/stepper": "^0.0.1",
    "@tvangular/time-line": "^0.0.9",
    "angular-chart.js": "^1.1.0",
    "aws-sdk": "^2.1693.0",
    "bootstrap": "^5.3.8",
    "chart.js": "^4.5.1",
    "chartjs-plugin-datalabels": "2.2.0",
    "docx-preview": "^0.4.0",
    "exceljs": "^4.4.0",
    "firebase": "^12.11.0",
    "font-awesome": "^4.7.0",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.8",
    "jwt-decode": "^4.0.0",
    "ngx-image-cropper": "^9.1.7",
    "ngx-skeleton-loader": "^8.1.0",
    "ngx-spinner": "^22.0.1",
    "ngx-toastr": "^20.0.5",
    "pdfjs-dist": "5.6.205",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular/build": "^22.1.5",
    "@angular/cli": "~22.1.5",
    "@angular/compiler-cli": "^22.1.3",
    "@commitlint/cli": "^21.2.2",
    "@commitlint/config-conventional": "^21.2.2",
    "@ngx-env/builder": "^22.0.0",
    "@types/jasmine": "~4.3.0",
    "@types/node": "^22.0.0",
    "commitizen": "^4.3.2",
    "compression-webpack-plugin": "^11.1.0",
    "cross-env": "^10.1.0",
    "cz-conventional-changelog": "^3.3.0",
    "dotenv": "^17.4.2",
    "husky": "^9.1.7",
    "jasmine-core": "~4.5.0",
    "jsdom": "^28.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "ng-packagr": "^22.1.1",
    "standard-version": "^9.5.0",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  }
}
